<label class="pickup-label{{mode ? ' -mode-'+mode : ' -mode-filter' }}" [ngClass]="{'is-disabled': disabled}"
    *ngIf="title" (click)="labelClicked($event)">
    <span class="pickup-label__inner">{{title}}</span>
</label>